import { Grid } from "@mui/material";
import { useAchievements } from "api/achievements";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { SelectInput } from "components/FormControls/Select/Select";
import { useMessage } from "hooks/intl";
import { useManageInfiniteScroll } from "hooks/useManageInfiniteScroll";
import { useState } from "react";
import { DefaultLanguageDataState } from "reduxState/translations/translationsSlice";

interface Props {
  achievementId?: string;
  defaultLang: DefaultLanguageDataState;
  isEditMode?: boolean;
}

export const Achievement = ({
  achievementId,
  defaultLang,
  isEditMode,
}: Props) => {
  const [achievementSearch, setSearchAchievement] = useState<string>();
  const { useAchievementData, useInfiniteAchievmentsList } = useAchievements();
  const { message } = useMessage();
  const { data: selectedAchievement } = useAchievementData(achievementId);

  const {
    data: infiniteAchievementsList,
    size: achievementsSize,
    setSize: setAchievementsSize,
    isValidating,
  } = useInfiniteAchievmentsList({
    filters: achievementSearch
      ? [
          {
            condition: "like",
            query: "name",
            value: achievementSearch,
          },
          {
            condition: "eq",
            query: "active",
            value: true,
          },
        ]
      : [
          {
            condition: "eq",
            query: "active",
            value: true,
          },
        ],
    order: "asc",
    sortKey: "name",
  });

  const {
    infiniteData: achievementsList,
    anyElementsToFetch: anyAchievementsToFetch,
  } = useManageInfiniteScroll(infiniteAchievementsList || []);

  const initialValue = selectedAchievement && {
    id: selectedAchievement.achievementId as string,
    label: selectedAchievement.translations[defaultLang.code]
      ? selectedAchievement.translations[defaultLang.code].name
      : "",
  };

  return (
    <Grid xs={6} mt={12} item>
      <SelectInput
        displaySearch
        data-test-id="campaign-trigger-achivement-search"
        width="100%"
        items={
          achievementsList.map((achievement) => ({
            label: achievement.name,
            id: achievement.achievementId,
          })) || []
        }
        label={
          <RequiredFieldLabel
            text={message({
              id: "achievement",
            })}
          />
        }
        name="achievementId"
        asyncSearch={(searchedQuery: string) =>
          setSearchAchievement(searchedQuery)
        }
        initialValue={initialValue}
        placeholder={message({ id: "achievement" })}
        anyElementsToFetch={anyAchievementsToFetch}
        loadMoreElements={() =>
          !isValidating && setAchievementsSize(achievementsSize + 1)
        }
        disabled={isEditMode}
      />
    </Grid>
  );
};
